module.exports = {"sclist":[{"sc":2300,"details":"AED   رسالة الحلم -  1 "},{"sc":3839,"details":"AED  المعنى العام للحلم -  3 "},{"sc":2665,"details":"AED تفسير أحلام - مختصر جداً - 5 "},{"sc":3772,"details":"AED تفسير أحلام - مميز - 15 "},{"sc":4966,"details":"AED أطفال (فريال) - 15 "},{"sc":3900,"details":"AED احلام - زهري - 10 "},{"sc":2304,"details":"AED احلام - أحمر - 10 "},{"sc":7994,"details":"AED احلام - جديد - 10 "},{"sc":7996,"details":"AED احلام - جديد - 10 "},{"sc":3877,"details":"AED رقم  - 50 "}]}


//////////////////
// WEBPACK FOOTER
// ./src/sc.json
// module id = 150
// module chunks = 0